module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "fork"
    }
  }, [_c('div', {
    staticClass: "hero is-dark"
  }, [_c('div', {
    staticClass: "hero-body has-text-centered"
  }, [_c('h2', {
    staticClass: "title is-3"
  }, [_vm._v("\n          Check out the code behind this site!\n        ")]), _vm._v(" "), _c('separator', {
    attrs: {
      "color": "white"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "subtitle is-5"
  }, [_vm._v("Fork it on GitHub.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block reveal"
  }, [_c('a', {
    staticClass: "button grow",
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": "https://github.com/arul21"
    }
  }, [_c('span', [_vm._v("Fork")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "code-fork",
      "size": "is-small"
    }
  })], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "reveal column is-narrow techs"
  }, [_c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/vue.png"),
      "alt": "Vue"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "reveal column is-narrow"
  }, [_c('span', {
    staticClass: "plus"
  }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "reveal column is-narrow techs"
  }, [_c('a', {
    attrs: {
      "href": "http://bulma.io/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/bulma.png"),
      "alt": "Bulma"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70353c9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fork.vue
// module id = 544
// module chunks = 1